import React, { SyntheticEvent } from 'react';
import { compose } from 'redux';
import CSSModules from 'react-css-modules';
import { Text, TextPreset, Color, Tag } from '@pegasus/ui-components/components/text';
import { injectConfig } from '@client/hoc/config';
import Translate from '@client/components/shared/translation/Translate';
import styles from './styles.scss';

export interface ReservedPopoverProps {
    handleClick: (args: SyntheticEvent) => void;
};

export const ReservedPopover: React.FunctionComponent<ReservedPopoverProps> = ({
    handleClick,
}) => (
        <div styleName="reserved-wrapper-popover">
            <div styleName="reserved-article-popover">
                <Text preset={TextPreset.M_BOLD} color={Color.dark} tag={Tag.DIV} styleName="reserved-article-headline">
                    <Translate message="article.reservedPopoverHeadline" />
                </Text>
                <Text preset={TextPreset.XS} color={Color.dark} tag={Tag.DIV} styleName="reserved-article-body">
                    <Translate message="article.reservedPopoverFirstLine" />
                </Text>
                <Text preset={TextPreset.XS} color={Color.dark} tag={Tag.DIV} styleName="reserved-article-body">
                    <Translate message="article.reservedPopoverSecondLine" />
                </Text>
                <div styleName="reserved-article-close" onClick={handleClick}>
                    <Text preset={TextPreset.XS} color={Color.dark}>
                        <Translate message="marketingOverlays.close" />
                    </Text>
                </div>
            </div>
        </div>
    );
export default compose(
    injectConfig,
    CSSModules(styles),
)(ReservedPopover);
